import { render } from "./recovery.vue?vue&type=template&id=012c14b8&scoped=true"
const script = {}

import "./recovery.vue?vue&type=style&index=0&id=012c14b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012c14b8"]])

export default __exports__